export const DEFAULT_MASKED_REVEAL_LIMIT = 1

export const MAX_MASKED_REVEAL_LIMIT = 10
